import Vue from "vue";
import Vuex from "vuex";
import {vuexOidcCreateStoreModule} from "vuex-oidc";
import {oidcSettings} from "@/oidc-config";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        oidcStore: vuexOidcCreateStoreModule(
            oidcSettings,
            {namespaced: true, dispatchEventsOnWindow: true}
        )
    },
    getters: {
        currentUser(state: any) {
            return state.oidcStore ? state.oidcStore.user : null;
        }
    }
});
